import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { TicketUsageRule } from '../../../../models/scan-testing.model';

// Configures a Ticket Usage rule: single vs multi-day, one-time vs unlimited
// entry. Seeds an extended test row carrying the usage designation.
@Component({
  selector: 'app-sr-ticket-usage-modal',
  templateUrl: './sr-ticket-usage-modal.component.html',
  standalone: false,
  styleUrls: ['./sr-modal-shared.scss']
})
export class SrTicketUsageModalComponent implements OnInit {
  @Input() initial?: TicketUsageRule;
  @Output() confirmed = new EventEmitter<TicketUsageRule>();
  @Output() cancelled = new EventEmitter<void>();

  dayUsage: 'single' | 'multi' = 'single';
  entryUsage: 'one_time' | 'unlimited' = 'one_time';

  ngOnInit(): void {
    if (this.initial) {
      this.dayUsage = this.initial.dayUsage;
      this.entryUsage = this.initial.entryUsage;
    }
  }

  setDayUsage(value: 'single' | 'multi'): void { this.dayUsage = value; }

  private newSeedKey(): string {
    return `tu_${Date.now()}_${Math.random().toString(36).slice(2, 8)}`;
  }

  onConfirm(): void {
    this.confirmed.emit({
      type: 'ticket_usage',
      dayUsage: this.dayUsage,
      entryUsage: this.entryUsage,
      seedKey: this.initial?.seedKey || this.newSeedKey()
    });
  }

  onCancel(): void {
    this.cancelled.emit();
  }
}
